import { userStore, dappStore } from '@components/store';
export const createOpenseaURL = (positionId: number) => {
  const addresses = dappStore.getState().addresses;
  return 'https://opensea.io/assets/ethereum/' + addresses.positionTokenAddress + '/' + positionId;
};
